export const selectSingleShoppingList = (state) => {
    return state.singleShoppingList;
};
